import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import RadioInput from "./RadioInput";
import WizardFooter from "./WizardFooter";
export const fields = ["tanf_three_years"];

const validate = (values, props) => {
  const errors = {};
  if (!values.tanf_three_years) {
    errors.tanf_three_years = props.allText.shared.required;
  }
  return errors;
};

export const WizardFormSection08 = props => {
  const {
    allText,
    fields: { tanf_three_years },
    handleSubmit,
    previousPage,
  } = props;
  const text = { ...allText.shared, ...allText.section08 };
  const progress = 7;
  return (
    <form onSubmit={handleSubmit} className="form-horizontal">
      <div className="wizard-page-content">
        <div className="page-title-container">
          <span className="page-title underline">{text.title}</span>
          <span className="wizard-text question-text">{text.subtitle}</span>
        </div>
        <div className="single-question-margin">
          <div className="primary-question">{text.primaryQuestion}</div>
          <RadioInput text={text} field={tanf_three_years} />
        </div>
      </div>
      <WizardFooter
        text={text}
        previousPage={previousPage}
        progress={progress}
      />
    </form>
  );
};

WizardFormSection08.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection08);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection08.js